import { io } from 'socket.io-client';

const WS_URL = process.env.REACT_APP_WS_URL || 'http://localhost:3000';

let socket = null;

export const websocketService = {
  connect: (token) => {
    if (socket?.connected) {
      return socket;
    }

    socket = io(WS_URL, {
      auth: { token },
      transports: ['websocket', 'polling'],
    });

    socket.on('connect', () => {
      console.log('✅ WebSocket connected');
    });

    socket.on('disconnect', () => {
      console.log('❌ WebSocket disconnected');
    });

    socket.on('error', (error) => {
      console.error('WebSocket error:', error);
    });

    return socket;
  },

  disconnect: () => {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  },

  subscribeToDispersal: (studentId, schoolId) => {
    if (socket) {
      socket.emit('dispersal:subscribe', { studentId, schoolId });
    }
  },
  subscribeToDismissal: (studentId, schoolId) => {
    if (socket) socket.emit('dispersal:subscribe', { studentId, schoolId });
  },

  subscribeToNotifications: () => {
    if (socket) {
      socket.emit('notification:subscribe');
    }
  },

  onDispersalUpdate: (callback) => {
    if (socket) {
      socket.on('dispersal:update', callback);
    }
  },
  onDismissalUpdate: (callback) => {
    if (socket) socket.on('dispersal:update', callback);
  },

  onNotification: (callback) => {
    if (socket) {
      socket.on('notification:new', callback);
    }
  },

  off: (event, callback) => {
    if (socket) {
      socket.off(event, callback);
    }
  },
};
